import React, { useEffect, useState } from "react";
//Redux
import { useSelector, useDispatch } from "react-redux";
//Styling
import "./collection_showcase.css";
//Child Comp
import { MovieTagCarousel } from "../MovieTag/MovieTagCarousel.js";
//API
import { getCollection } from "../../api/apiSetUp.js";
//Utility
import { extractDetailData } from "../../utility/utility.js";

export const CollectionShowCase = (props) => {
  let [collectionData, setCollectionData] = useState(null);
  let [collectionLoading, setLoading] = useState(true);
  let [collectionError, setError] = useState(false);
  let langConfig = useSelector(
    (state) => state.apiUtility.apiUtility.langConfig
  );
  let genreList = useSelector(
    (state) => state.apiUtility.apiUtility["movGenreList"]
  );

  let name, backdrop_path, parts, overview, detailData, collectionId;
  if (props.detailData) {
    detailData = props.detailData;
    name = detailData.name;
    backdrop_path = detailData.backdrop_path;
    parts = detailData.parts;
    overview = detailData.overview;
  }

  if (props.collectionId) {
    collectionId = props.collectionId;
  }

  useEffect(() => {
    if (!detailData && collectionId) {
      async function getCollectionData(id) {
        let collection_response = await getCollection(id);
        collection_response.parts = collection_response.parts.map((item) =>
          extractDetailData("mov", item, langConfig, genreList, true)
        );
        collection_response.backdrop_path =
          "https://www.themoviedb.org/t/p/original" +
          collection_response.backdrop_path;
        console.log(collection_response);
        setCollectionData(collection_response);
        setLoading(false);
        return collection_response;
      }
      getCollectionData(collectionId);
    } else {
      setLoading(false);
    }
  }, [detailData, collectionId]);

  //Return
  if (!detailData && !collectionId) {
    return <></>;
  }

  if (detailData && !collectionLoading) {
    return (
      <div className="mov_collection_showcase_container">
        <div className="collection_showcase_title">
          {"This movie belongs to: " + name}
        </div>
        <div className="collection_showcase_content_wrapper">
          <img className="collection_showcase_background" src={backdrop_path} />
          <div className="collection_showcase_content">
            <div className="collection_showcase_content_title">{name}</div>
            <div className="collection_showcase_overview custom_scrollbar">
              {overview}
            </div>
            <div className="collection_showcase_list">
              <MovieTagCarousel
                isHoverEnable={false}
                movieItems={parts}
                isGrid={false}
                isDefaultSmall={true}
                movieType="mov"
              />
            </div>
          </div>
        </div>
      </div>
    );
  } else if (collectionLoading || !collectionData) {
    return <div>Collection Loading ... </div>;
  } else if (collectionData && !collectionLoading) {
    return (
      <div className="mov_collection_showcase_container">
        <div className="collection_showcase_content_wrapper">
          <img
            className="collection_showcase_background"
            src={collectionData.backdrop_path}
          />
          <div className="collection_showcase_content">
            <div className="collection_showcase_content_title">
              {collectionData.name}
            </div>
            <div className="collection_showcase_overview custom_scrollbar">
              {collectionData.overview}
            </div>
            <div className="collection_showcase_list">
              <MovieTagCarousel
                isHoverEnable={false}
                movieItems={collectionData.parts}
                isGrid={false}
                isDefaultSmall={true}
                movieType="mov"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
};
